import { useState } from 'react'
import { observer } from 'mobx-react'

import { Separator } from '../../components/app-layout/separator/separator'
import { Header } from '../../components/app-layout'
import { UncompletedActionsCarousel } from '../../components/uncompleted-actions-carousel/component'
import { Statistics } from './components/statistics/statistics'
import { Welcome } from './components/welcome/welcome'
import { BecomeAffiliateModal } from '../../components/affiliate/become-affiliate-modal/become-affiliate-modal'
import { TcModal } from '../../components/affiliate/tc-modal/tc-modal'
import { useRedirect } from '../../services/router'
import { routes } from '../../routes'
import { useMutation, useStore } from '../../utils/mst-hooks'
import './home.scss'
import { InstallAppBanner } from '../../components/install-app-banner/install-app-banner'

export const Home = observer(({ hideLogo }: { hideLogo: boolean }) => {
  const [showBecomeAffiliateModal, setShowBecomeAffiliateModal] = useState(false)
  const [showAffiliateTcModal, setShowAffiliateTcModal] = useState(false)

  const redirect = useRedirect()

  const { logged, markClientAsAffiliate } = useStore().data
  const [, markClientAsAffiliateRequest] = useMutation(markClientAsAffiliate, {
    onSuccess: () => {
      redirect(routes.affiliateDashboard, {})
    },
  })

  return (
    <div className="Home">
      {logged && <InstallAppBanner />}
      <Header hideLogo={hideLogo} />
      <Separator.Vertical height={40} />
      <Welcome />
      <Separator.Vertical height={23} />
      <UncompletedActionsCarousel openBecomeAffiliateModal={() => setShowBecomeAffiliateModal(true)} />
      <Separator.Vertical height={37} />
      <Statistics />
      <Separator.Vertical height={200} />
      <BecomeAffiliateModal
        showBecomeAffiliateModal={showBecomeAffiliateModal}
        setShowBecomeAffiliateModal={setShowBecomeAffiliateModal}
      />
      <TcModal
        onContinue={() => {
          setShowBecomeAffiliateModal(false)
          setShowAffiliateTcModal(false)
          markClientAsAffiliateRequest({})
        }}
        showModal={showAffiliateTcModal}
        setShowModal={setShowAffiliateTcModal}
      />
    </div>
  )
})
